import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { Form } from "@unform/web";
import { FormHandles } from "@unform/core";
import { Box, MenuItem } from "@mui/material";

import { toast } from "react-toastify";
import {
    Typography,
    PageContainer,
    GreyContainer,
    CheckboxInput,
    InnerContentContainer,
    ImageInput,
    Input,
    SelectInput,
    FixedSaveBar,
} from "../../../components";
import { RemoveIcon } from "../../../components/elements/Icons";
import { CreateModule, RelatedItemCard, RelatedActions, LoadingRelatedItemCard, CourseTeachers } from "../../../components/features/Producer_bkp";
import { ConfirmModal, Alert } from "../../../components/elements";
import { CourseCategoryType } from "../../../types/course";
import CourseCategoryService from "../../../services/course_categories.service";
import { multipartHeaders } from "../../../services/config";
import ProdCourseService from "../../../services/prod.course.service";
import ProdCourseModuleService from "../../../services/prod.coursemodule.service";

export interface Props {}

const CreateCourse: React.FC<Props> = ({ ...props }) => {
    const [coursesCategories, setCoursesCategories] = useState([]);
    const [courseId, setCourseId] = useState<null | number>(null);
    const [modules, setModules] = useState<null | any[]>(null);
    const [teachersIds, setTeachersIds] = useState<any[]>([]);
    const [teacherError, setTeacherError] = useState<null | string>(null);
    const [loadingModules, setLoadingModules] = useState(false);
    const [initialSelectedTeachers, setInitialSelectedTeachers] = useState<any[] | []>([]);
    const formRef = useRef<FormHandles>(null);
    const { slug } = useParams<{ slug: string }>();

    const getModules = () => {
        setLoadingModules(true);
        const prodCourseService = new ProdCourseService();
        prodCourseService.get_modules(courseId).then((response) => {
            setModules(response);
            setLoadingModules(false);
        });
    };

    const deleteModule = (id: number) => {
        const prodCourseModuleService = new ProdCourseModuleService();
        prodCourseModuleService.delete(id).then((response) => {
            //console.log("Deleted", response);
        });
    };

    useEffect(() => {
        if (courseId) {
            setLoadingModules(true);
            const prodCourseService = new ProdCourseService();
            prodCourseService.get_modules(courseId).then((response) => {
                setModules(response);
                setLoadingModules(false);
            });
        }
    }, [courseId]);

    const setInitialTeachersData = (teachers: any) => {
        const teachersData = teachers.map((teacher: any) => ({
            id: teacher.id,
            name: teacher.nome,
            description: teacher.descricao,
            imageUrl: teacher.foto,
        }));
        setInitialSelectedTeachers(teachersData);
    };

    useEffect(() => {
        if (slug) {
            //console.log("SLUG", slug);
            const prodCourseService = new ProdCourseService();
            prodCourseService.get_by_slug(slug).then((response) => {
                //	console.log("CYKA", response);
                setCourseId(response.id);
                if (response.professores) {
                    const professoresIds = response.professores.map((teacher: any) => teacher.id);

                    setTeachersIds(professoresIds);
                    setInitialTeachersData(response.professores);
                }

                formRef?.current?.setData({ ...response, categoria_id: response.categoria.id });
            });
        }
    }, [slug]);

    useEffect(() => {
        const courseCategoryService = new CourseCategoryService();
        courseCategoryService.list().then((response) => {
            setCoursesCategories(response);
        });
    }, []);

    const createCourse = (data: any) => {
        const prodCourseService = new ProdCourseService();

        prodCourseService.create({ ...data, professores_ids: teachersIds }, multipartHeaders).then((response) => {
            if (response.error) {
                const validationErrors: any = {};
                // Object.keys(response.data).map((error: any) => {
                // 	validationErrors[error] = response.data[error][0];
                // 	return true;
                // });
                formRef?.current?.setErrors(validationErrors);
            } else {
                setCourseId(response.data.id);
                toast.success("Curso Criado!");
            }
        });
    };

    const updateCourse = (data: any) => {
        const prodCourseService = new ProdCourseService();

        prodCourseService.update(courseId, { ...data, professores_ids: teachersIds }, multipartHeaders).then((response) => {
            //console.log(response);
            if (response.error) {
                const validationErrors: any = {};
                // Object.keys(response.data).map((error: any) => {
                // 	validationErrors[error] = response.data[error][0];
                // 	return true;
                // });
                formRef?.current?.setErrors(validationErrors);
            } else {
                setCourseId(response.data.id);
                toast.success("Alterado com sucesso!");
            }
        });
    };

    async function handleSubmit(data: any) {
        try {
            formRef?.current?.setErrors({});
            setTeacherError(null);
            const schema = Yup.object().shape({
                nome: Yup.string().required("Este campo é obrigatório."),
                categoria_id: Yup.string().required("Este campo é obrigatório."),
            });
            await schema.validate(data, {
                abortEarly: false,
            });
            if (courseId && teachersIds.length < 1) {
                setTeacherError("Inclua ao menos um professor ao curso.");
                return;
            }

            if (!courseId) {
                createCourse(data);
            } else {
                updateCourse(data);
            }
        } catch (err) {
            const validationErrors: any = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error: any) => {
                    validationErrors[error.path] = error.message;
                });
                formRef?.current?.setErrors(validationErrors);
            }
            //console.log(validationErrors);
        }
    }

    const submitForm = () => {
        formRef?.current?.submitForm();
    };

    const checkBoxOptions = {
        ativo: {
            id: "ativo",
            name: "ativo",
            value: "ativo",
            label: "Ativo",
            helpText: "",
        },
        comentarios_ativos: {
            id: "comentarios_ativos",
            name: "comentarios_ativos",
            value: "comentarios_ativos",
            label: "Aceitando Comentários",
            helpText: "Os alunos deste podem fazer comentários.",
        },
        curso_completo: {
            id: "curso_completo",
            name: "curso_completo",
            value: "curso_completo",
            label: "Finalizado",
            helpText: "Todas as aulas estão disponíveis.",
        },
        requer_questionarios_conclusao: {
            id: "requer_questionarios_conclusao",
            name: "requer_questionarios_conclusao",
            value: "requer_questionarios_conclusao",
            label: "Requer Questionário Para Conclusão",
            helpText: "",
        },
        certificado: {
            id: "certificado",
            name: "certificado",
            value: "certificado",
            label: "Este curso emite certificado",
            helpText: "Cadastre seu certificado",
        },
    };

    return (
        <PageContainer pageTitle={courseId ? "Editar Curso" : "Novo Curso"} showBreadcrumb showSearch={false}>
            <GreyContainer>
                <InnerContentContainer>
                    <Typography variant="title" size="22px">
                        Informações Gerais
                    </Typography>
                    <Form ref={formRef} onSubmit={handleSubmit} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <Box marginTop="20px" marginBottom="30px" display="grid" gridTemplateColumns="1fr 1fr" columnGap="20px">
                            <Input name="nome" label="Nome" />
                            <SelectInput name="categoria_id" label="Categoria">
                                {coursesCategories.map((option: CourseCategoryType) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </SelectInput>
                        </Box>
                        <Box display="grid" columnGap="20px" gridTemplateColumns="repeat(4, 1fr)">
                            <CheckboxInput {...checkBoxOptions.ativo} />
                            <CheckboxInput {...checkBoxOptions.comentarios_ativos} />
                            <CheckboxInput {...checkBoxOptions.curso_completo} />
                            <CheckboxInput {...checkBoxOptions.requer_questionarios_conclusao} />
                        </Box>
                        <Box marginTop="30px" display="grid" gridTemplateColumns="0.96fr 3fr" columnGap="20px">
                            <ImageInput name="imagem" label="Imagem" />
                            <Input name="email_suporte" type="email" label="E-mail suporte" />
                        </Box>
                        <Box display="grid" gridTemplateColumns="1fr">
                            <Input name="descricao" label="Descrição do curso" />
                        </Box>
                        <Box display="grid" gridTemplateColumns="auto auto">
                            <Typography margin="30px 0 30px 0" variant="title" size="22px">
                                Módulos
                            </Typography>

                            {courseId && <CreateModule courseId={courseId} updateModules={getModules} />}
                            <Box display="grid" gridTemplateRows="auto" rowGap="5px" gridColumn="1/3">
                                {!courseId && <Alert variant="warning" text="Para incluir módulos salve as informações básicas primeiro." />}
                                {loadingModules && (
                                    <>
                                        <LoadingRelatedItemCard />
                                        <LoadingRelatedItemCard />
                                        <LoadingRelatedItemCard />
                                    </>
                                )}
                                {modules?.map(
                                    (module: {
                                        id: number;
                                        name: string;
                                        order: number;
                                        description: string;
                                        releaseDate: string;
                                        classesCount: number;
                                    }) => (
                                        <RelatedItemCard order={module.order} title={module.name} subtitle={module.releaseDate}>
                                            <Box display="grid" gridTemplateColumns="75px auto 90px" width="100%">
                                                <Box display="flex" alignItems="center" justifyContent="flex-start">
                                                    <Typography variant="text" size="1.25rem" fontWeight="bold">
                                                        {module.classesCount}
                                                    </Typography>
                                                    <Typography margin="0 0 0 5px" variant="text" color="#9a9a9a" size="0.875rem">
                                                        {module.classesCount > 1 ? "aulas" : "aula"}
                                                    </Typography>
                                                </Box>
                                                <Box display="flex" alignItems="center">
                                                    <Typography variant="text" size="0.75rem">
                                                        {module.description}
                                                    </Typography>
                                                </Box>
                                                <Box display="flex" justifyContent="flex-end">
                                                    <RelatedActions
                                                        editComponent={
                                                            <CreateModule courseId={courseId} module={module} updateModules={getModules} />
                                                        }
                                                        removeComponent={
                                                            <ConfirmModal
                                                                title="Remover Módulo"
                                                                text={`Tem certeza que deseja remover o modulo "${module.name}"? `}
                                                                OpenButton={<RemoveIcon />}
                                                                onConfirm={() => {
                                                                    deleteModule(module.id);
                                                                }}
                                                            />
                                                        }
                                                    />
                                                </Box>
                                            </Box>
                                        </RelatedItemCard>
                                    )
                                )}
                            </Box>
                        </Box>
                        <CourseTeachers
                            formRef={formRef}
                            teacherError={teacherError}
                            initialTeachers={initialSelectedTeachers}
                            setTeachersIds={(teachersIds: number[]) => {
                                setTeachersIds(teachersIds);
                            }}
                        />
                        <Typography margin="30px 0 30px 0" variant="title" size="22px">
                            Certificado
                        </Typography>
                        <Box display="grid" gridTemplateColumns="1fr">
                            <CheckboxInput {...checkBoxOptions.certificado} />
                        </Box>
                        <Box margin="20px 0" display="grid" gridTemplateColumns="1fr 1fr" columnGap="20px">
                            <ImageInput name="certificado_frente" label="Frente" />
                            <ImageInput name="certificado_verso" label="Verso" />
                        </Box>
                        <Box display="grid" gridTemplateColumns="1fr">
                            <Input name="certificado_texto" label="Texto do certificado" />
                            <Typography margin="5px 0 0 0" variant="helptext" size="0.75rem">
                                Para inserir um campo personalizado, digite <b>"[nome_do_campo]"</b> (sem aspas) no local desejado. <br /> Campos
                                disponíveis: <b>[nome], [cpf]</b>
                            </Typography>
                        </Box>
                    </Form>
                </InnerContentContainer>
            </GreyContainer>
            <FixedSaveBar saveAction={submitForm} cancelAction={() => console.log("KDDD")} />
        </PageContainer>
    );
};
export { CreateCourse };
